import api from "config/axios/axios.api.config";

const getFAQS = (id) => {
  const data = api.get(`knowledge/${id}/faq`);
  return data;
};

// eslint-disable-next-line
export default getFAQS;
